import React, { useEffect, useState } from "react"
import { Checkbox } from "ksc-portal-common-components/atoms"
import { Button } from "ksc-portal-common-components/shadcn"
import { useCookies } from "react-cookie"

type LoginHeroVideoProps = {
  renderPrivacyPolicy: () => void
  children: React.ReactNode
}

const LoginHeroVideo = ({
  renderPrivacyPolicy,
  children,
}: LoginHeroVideoProps) => {
  const [cookies, setCookies] = useCookies(["run-hero-animation"])
  const [doesSecondaryLogoExist, setDoesSecondaryLogoExist] = useState(false)

  const [runAnimation, setRunAnimation] = useState(
    cookies["run-hero-animation"]
      ? JSON.parse(cookies["run-hero-animation"])
      : true
  )

  const checkIfSecondaryLogoExists = async () => {
    const result = await fetch("/public/images/secondary-logo.svg", {
      method: "GET",
    })
      .then((res) => {
        const contentType = res.headers.get("Content-Type")
        return contentType.includes("image/svg+xml")
      })
      .catch((e) => {
        console.error(e)
        return false
      })
    setDoesSecondaryLogoExist(result)
  }

  useEffect(() => {
    checkIfSecondaryLogoExists()
  }, [])

  const onChange = () => {
    setRunAnimation(!runAnimation)
    setCookies("run-hero-animation", !runAnimation, { path: "/" })
    const heroVideo = document.getElementById("hero-video")
    if (runAnimation) heroVideo.pause()
    else heroVideo.play()
  }
  return (
    <>
      <video
        className="absolute z-0 w-auto h-auto min-w-full min-h-full object-cover"
        id="hero-video"
        data-testid="hero-video"
        loop
        muted
        playsInline
        autoPlay={runAnimation}
      >
        <source
          src="https://www.kaizenreporting.com/wp-content/uploads/2023/08/hero-1.mp4"
          type="video/mp4"
        />
      </video>
      <div id="logo" className="fixed top-2 right-6 !h-auto !w-32" />
      {doesSecondaryLogoExist && (
        <img
          id="secondary-logo"
          src="/public/images/secondary-logo.svg"
          alt="Secondary logo"
          className="fixed top-4 left-6 !h-auto max-w-[128px]"
        />
      )}
      <div className="relative z-10 w-full max-w-6xl px-4 flex flex-col lg:flex-row items-center justify-center gap-8">
        <div className="text-center lg:text-left text-black lg:w-1/2 lg:pr-16">
          <p className="text-4xl lg:text-[56px] font-bold mb-4 text-primary lg:leading-[64px]">
            Revolutionising Compliance
          </p>
          <p className="text-xl lg:text-xl text-muted-foreground font-medium">
            Transform how you meet your compliance and regulatory reporting
            obligations
          </p>
        </div>
        {children}
        <div className="hidden md:block hero-animation-checkbox">
          <Checkbox
            option={{
              label: `Don't show background animation`,
              value: "true",
            }}
            isChecked={!runAnimation}
            onChange={onChange}
            testId="hero-animation-toggle"
            name="hero-animation-checkbox"
          />
        </div>
        <div className="copyright-text-styling left-[40px] md:left-auto">
          © {new Date().getFullYear()} Kaizen Reporting Ltd. All rights
          reserved.
          <Button
            variant="link"
            onClick={renderPrivacyPolicy}
            data-testid="privacy-policy-link"
          >
            Privacy Policy
          </Button>
        </div>
      </div>
    </>
  )
}

export default LoginHeroVideo
